import { Button, Input, Modal, Space } from 'antd';
import { observer } from 'mobx-react';
import React, { useContext, useEffect, useState } from 'react';
import { rootContext } from 'stores';

import './Editregion.scss';

const Editregion: React.FC = observer(() => {
  const {
    RegionStore: {
      editRegion,
      state: { data, ui },
      setState
    }
  } = useContext(rootContext);

  const [region, setRegion] = useState<string>(data.editRegionData?.name || '');

  const onCloseRegionModal = () => {
    setState({ data: { ...data, editRegionData: null } });
  };

  useEffect(() => {
    return () => {
      setRegion('');
    };
  }, [data.editRegionData]);

  return (
    <div className="EditregionStyles">
      <Modal
        title="Edit Region"
        footer={false}
        visible={data.editRegionData ? true : false}
        destroyOnClose={true}
        onCancel={onCloseRegionModal}
        afterClose={onCloseRegionModal}
      >
        <Space>
          <Input
            value={region || data.editRegionData?.name}
            onChange={e => setRegion(e.target.value)}
          />
          <Button
            type="primary"
            className="primary_btn"
            onClick={() =>
              data.editRegionData &&
              editRegion({
                id: data.editRegionData.id,
                name: region
              })
            }
          >
            Edit
          </Button>
        </Space>
      </Modal>
    </div>
  );
});

export default Editregion;
